<div class="container-fluid" *ngIf="!isLoading">
  <div class="row">
    <div class="col-lg-8">
      <div class="card">
        <div class="card-body">
          <h6>Productos comprados</h6>
          <table class="table table-sm table-bordered table-hover">
            <thead>
              <tr>
                <th>Artículo</th>
                <th>Cantidad</th>
                <th>Descuento</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody *ngFor="let prod of detailPayment?.items; let i = index">
              <tr style="background: #f5f5f5">
                <td>
                  <small>
                    <span
                      class="badge badge-info"
                      *ngIf="prod.product.isCommon"
                    >
                      Común
                    </span>
                    {{ prod.product.name | uppercase }}
                  </small>
                </td>
                <td>
                  <span *ngIf="prod.variants.length === 0">
                    {{ getQuantity(prod) | number }}
                    <span class="text-danger" *ngIf="prod.product?.refund"
                      >-{{ prod.product.refund | number }}</span
                    >
                  </span>
                </td>
                <td>
                  <span *ngIf="prod.variants.length === 0"
                    >${{ prod.product?.discountTotal || 0 | number }}</span
                  >
                </td>
                <td>
                  <span *ngIf="prod.variants.length === 0">
                    ${{ prod.product.price * prod.quantity | number }}</span
                  >
                </td>
              </tr>
              <tr *ngFor="let variant of prod.variants">
                <td>
                  <i class="fa fa-long-arrow-right"></i>
                  {{ variant.variantName }}
                </td>
                <td>
                  {{ variant.quantity | number }}
                  <span class="text-danger" *ngIf="variant?.refund">
                    -{{ variant.refund | number }}
                  </span>
                </td>
                <td>${{ variant.discountTotal || 0 | number }}</td>
                <td>
                  ${{ variant.price < 0 ? "-" : ""
                  }}{{ variant.price * variant.quantity | number }}
                </td>
              </tr>
            </tbody>
          </table>
          <!-- SECTION BUTTONS REFUND AND CHANGE -->
          <h3
            *ngIf="detailPayment?.isDelete"
            class="text-danger mt-2 text-center"
          >
            Orden eliminada <i class="fa fa-trash"></i>
          </h3>
          <div class="row mt-2" *ngIf="!detailPayment?.isDelete">
            <div class="col-12 align-items-center text-end">
              <button class="btn btn-primary me-2" (click)="openModal(pay)">
                <i class="fa fa-mail-reply"></i> Reembolsar
              </button>

              <button
                class="btn btn-info me-2"
                (click)="openModalChange(change)"
              >
                <i class="fa fa-random"></i> Cambiar
              </button>

              <button class="btn btn-dark" (click)="printBill()">
                <i class="fa fa-print"></i> Imprimir recibo
              </button>

              <!-- MODAL CHANGE SIMPLE -->
              <ng-template #change let-modal>
                <div class="modal-header">
                  <h6>Cambiar producto</h6>
                </div>
                <div class="modal-body">
                  <table class="table table-sm table-bordered table-striped">
                    <thead>
                      <tr>
                        <th>Producto</th>
                        <th>Var.</th>
                        <th>Cant./Reem.</th>
                        <th>A&nbsp;devolver</th>
                      </tr>
                    </thead>
                    <tbody
                      *ngFor="let prod of detailPayment?.items; let i = index"
                    >
                      <tr style="background: #f5f5f5">
                        <td>
                          <small
                            ><b>{{ prod.product.name | uppercase }}</b></small
                          >
                        </td>
                        <td>
                          {{ getQuantity(prod) | number }}
                          <span class="text-danger" *ngIf="prod.product?.refund"
                            >-{{ prod.product.refund | number }}</span
                          >
                        </td>

                        <td>${{ getTotal(prod) | number }}</td>
                        <td>
                          <span *ngIf="prod?.product.isRefund"
                            >Reembolsado</span
                          >
                          <input
                            *ngIf="
                              !prod?.product.isRefund &&
                              !prod?.product.isChange &&
                              prod.variants.length === 0
                            "
                            type="number"
                            class="form-control form-control-sm"
                            [max]="prod.quantity"
                            [min]="0"
                            [id]="'quantityChangeSimple-' + i"
                          />
                        </td>
                      </tr>
                      <tr *ngFor="let variant of prod.variants; let ii = index">
                        <td>
                          <i class="fa fa-long-arrow-right"></i>
                          {{ variant.variantName }}
                        </td>
                        <td>
                          {{ variant.quantity | number }}
                          <span class="text-danger" *ngIf="variant?.change"
                            >-{{ variant.change | number }}</span
                          >
                        </td>
                        <td>
                          ${{ variant.quantity * variant.price | number }}
                        </td>
                        <td>
                          <span *ngIf="variant?.isChange">Cambio</span>
                          <input
                            *ngIf="!variant?.isRefund && !variant?.isChange"
                            type="number"
                            class="form-control form-control-sm"
                            [max]="variant.quantity"
                            [min]="0"
                            [id]="'quantityChangeVariant-' + ii"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="modal-footer">
                  <button class="btn btn-dark" (click)="changeProducts()">
                    Cambiar
                  </button>
                </div>
              </ng-template>

              <!-- MODAL REFUND SIMPLE -->
              <ng-template #pay let-modal>
                <div class="modal-header">
                  <h6>Reembolsar productos</h6>
                </div>
                <div class="modal-body">
                  <table class="table table-sm table-bordered table-striped">
                    <thead>
                      <tr>
                        <th>Producto</th>
                        <th>Var.</th>
                        <th>Cant./Reem.</th>
                        <th>A&nbsp;devolver</th>
                      </tr>
                    </thead>
                    <tbody
                      *ngFor="let prod of detailPayment?.items; let i = index"
                    >
                      <tr style="background: #f5f5f5">
                        <td>
                          <small>{{ prod.product.name | uppercase }}</small>
                        </td>
                        <td>
                          {{ getQuantity(prod) | number }}
                          <span class="text-danger" *ngIf="prod.product?.refund"
                            >-{{ prod.product.refund | number }}</span
                          >
                        </td>

                        <td>${{ getTotal(prod) | number }}</td>
                        <td>
                          <span *ngIf="prod?.product.isRefund"
                            >Reembolsado</span
                          >
                          <input
                            *ngIf="
                              !prod?.product.isRefund &&
                              !prod?.product.isChange &&
                              prod.variants.length === 0
                            "
                            type="number"
                            class="form-control form-control-sm"
                            [max]="prod.quantity"
                            [min]="0"
                            [id]="'quantitySimple-' + i"
                          />
                        </td>
                      </tr>
                      <tr *ngFor="let variant of prod.variants; let ii = index">
                        <td>
                          <i class="fa fa-long-arrow-right"></i>
                          {{ variant.variantName }}
                        </td>
                        <td>
                          {{ variant.quantity | number }}
                          <span class="text-danger" *ngIf="variant?.refund"
                            >-{{ variant.refund | number }}</span
                          >
                        </td>
                        <td>
                          ${{ variant.quantity * variant.price | number }}
                        </td>
                        <!-- <td>${{ variant.price | number }}</td>
                        <td>${{ variant.quantity * variant.price | number }}</td>
                        <td>-</td> -->
                        <td>
                          <span *ngIf="variant?.isRefund">Reembolsado</span>
                          <input
                            *ngIf="!variant?.isRefund && !variant?.isChange"
                            type="number"
                            class="form-control form-control-sm"
                            [max]="variant.quantity"
                            [min]="0"
                            [id]="'quantityVariant-' + ii"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="modal-footer">
                    <button class="btn btn-dark" (click)="refundVariant()">
                      Reembolsar
                    </button>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-4" *ngIf="!isLoading">
      <div class="card">
        <div class="card-body">
          <h5>Detalle</h5>
          <ul class="list-group">
            <li class="list-group-item">
              <b>Fecha: </b
              >{{ detailPayment?.createdAt | date : "dd-MM-YYYY hh:mm:ss" }}
            </li>
            <li class="list-group-item">
              <b>Orden: </b>{{ detailPayment?.orderId }}
            </li>
          </ul>
          <h5 class="mt-3">Persona</h5>
          <ul class="list-group">
            <li class="list-group-item">
              <b>Cajero: </b>{{ detailPayment?.cashier?.name }}
            </li>
            <li class="list-group-item">
              <b>Sucursal: </b>{{ detailPayment?.subsidiary?.name }}
            </li>
          </ul>
          <h5 class="mt-3">Método de pago</h5>
          <ul class="list-group">
            <li
              class="list-group-item"
              *ngFor="let pm of getArray(detailPayment.payment)"
            >
              <b>{{ pm.paymentMethod.split("|")[1] }}: </b> ${{
                pm.amount | number
              }}
            </li>
          </ul>
          <h5 class="mt-3">Detalle compra</h5>
          <ul class="list-group" *ngIf="!!detailPayment">
            <li class="list-group-item">
              <b>Subtotal:</b> ${{ detailPayment?.subtotal | number }}
            </li>
            <li class="list-group-item">
              <b>IVA:</b> ${{ detailPayment?.iva | number }}
            </li>
            <li class="list-group-item">
              <b>Vuelto:</b> ${{ detailPayment?.exchange | number }}
            </li>
            <li class="list-group-item">
              <b>Descuento:</b> -${{ detailPayment?.discount | number }}
            </li>
            <!-- <li class="list-group-item bg-danger">
              <b>Reembolsado:</b> ${{ getTotalRefund() | number }}
            </li> -->
            <li class="list-group-item">
              <b>Total:</b> ${{ detailPayment?.total | number }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- RECEIPE BILL -->
<div id="componentID" style="display: none">
  <div
    style="
      width: 50mm;
      font-size: 10px;
      text-align: center;
      font-family: Arial, Helvetica, sans-serif;
    "
  >
    <h4>VETCANT</h4>
    <span>Almirante Riveros #1379 <br />San Bernardo</span>
    <br />
    <span>+56 9 6631 4463</span>
    <br />
    <span><b>clinicaveterinaria.vetcant@gmail.com</b></span>
    <br />
    <br />
    <hr />
    <table style="width: 50mm; font-size: 8px; text-align: left">
      <tr>
        <td width="auto">Cajero:</td>
        <td>{{ detailPayment?.cashier?.name }}</td>
      </tr>
      <tr>
        <td>Sucursal:</td>
        <td>
          {{ detailPayment?.subsidiary?.name }}
        </td>
      </tr>
      <tr>
        <td>Fecha:</td>
        <td>{{ getToday() }}</td>
      </tr>
      <tr *ngFor="let pm of getArray(detailPayment.payment)">
        <td>{{ pm.paymentMethod.split("|")[1] }}</td>
        <td>${{ pm.amount | number }}</td>
      </tr>
    </table>

    <hr />
    <table style="width: 50mm; font-size: 8px">
      <ng-container *ngFor="let pd of detailPayment?.items">
        <ng-container *ngIf="pd.variants.length > 0">
          <tr>
            <td style="text-align: left">
              <b
                >{{ cartService.getVariantsQuantity(pd.variants) | number }} x
                {{ pd.product.name | titlecase }}</b
              >
            </td>
            <td style="text-align: right">
              <b>${{ cartService.getVariantsTotal(pd.variants) | number }}</b>
            </td>
          </tr>
          <ng-container *ngFor="let va of pd.variants">
            <tr>
              <td style="text-align: left">
                <small
                  >{{ va.quantity }} x {{ va.variantName | uppercase }}</small
                >
              </td>
              <td style="text-align: right">
                <small>${{ va.quantity * va.price | number }}</small>
              </td>
            </tr>
            <tr *ngIf="va?.discount">
              <td style="text-align: left">
                (-{{ va?.discountType === "clp" ? "$" : "" }}{{ va.discount
                }}{{ va?.discountType === "percent" ? "%" : "" }})
              </td>
              <td style="text-align: right">
                -${{ va.discountTotal | number }}
              </td>
            </tr>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="pd.variants.length === 0">
          <tr>
            <td style="text-align: left">
              <b> {{ pd.quantity }} x {{ pd.product.name | titlecase }}</b>
            </td>
            <td style="text-align: right">
              <b> ${{ pd.quantity * pd.product.price | number }}</b>
            </td>
          </tr>
          <tr *ngIf="pd?.product.discount">
            <td style="text-align: left">
              <small>(-{{ pd.product.discount | number }}%)</small>
            </td>
            <td style="text-align: right">
              <small>$-{{ pd.product.discountTotal | number }}</small>
            </td>
          </tr>
        </ng-container>
      </ng-container>
      <tr>
        <td colspan="2"><hr /></td>
      </tr>
      <tr>
        <td colspan="2" style="text-align: right">
          <b>Subtotal: ${{ detailPayment?.subtotal | number }}</b>
        </td>
      </tr>
      <tr>
        <td colspan="2" style="text-align: right">
          <b>IVA: ${{ detailPayment?.iva | number }}</b>
        </td>
      </tr>
      <tr>
        <td colspan="2" style="text-align: right">
          <b>Descuento: -${{ detailPayment?.discount | number }}</b>
        </td>
      </tr>
      <tr>
        <td colspan="2" style="text-align: right">
          <b>Vuelto: ${{ detailPayment?.exchange | number }}</b>
        </td>
      </tr>
      <tr>
        <td colspan="2" style="text-align: right">
          <b>TOTAL: ${{ detailPayment?.total | number }}</b>
        </td>
      </tr>
      <tr>
        <td colspan="2">
          <hr />
        </td>
      </tr>
    </table>

    <!-- TEMPLATE TICKET -->
    <!-- <ng-container *ngFor="let item of [].constructor(tickets)">
      <p style="font-size: 10px">
        Para realizar un cambio de producto por favor acercate a nuestra tienda
        ubicada en <b>Almirante Riveros 1379, San Bernardo</b>. Presenta este
        código en caja <b>#{{ orderId }}</b
        >. Válido sólo por 30 días después de la fecha de compra
        <b>{{ getToday() }}</b>
      </p>
      <hr />
    </ng-container> -->
  </div>
</div>
